<template>
  <div class="metric-studio-side-panel">
    <vue-headful :title="`Studio | Locale.ai`" />
    <header class="panel-header">
      <!-- <div class="title-area">
        <icon
          v-if="getConfig && !getConfig.isPublicView"
          type="button"
          @click="$router.push('/consoles')"
          >arrow_back</icon
        >
        <h1
          :class="[
            'title',
            { 'pad-10 pad-left-15': getConfig && getConfig.isPublicView },
          ]"
        >
          {{ getDashboardName }}
        </h1>
        <expand />
        <Button
          v-if="getConfig.isTempWidgets && !$route.query.dashboard_id"
          type="primary"
          text="save"
          :style="{ marginRight: '10px' }"
          @click="$emit('clickSave', { showSaveAsNewButton: false })"
        />
        <ButtonWithDropdown
          v-else-if="getConfig.isTempWidgets && $route.query.dashboard_id"
          type="primary"
          text="save"
          :style="{ marginRight: '10px' }"
          @click="emitSaveOrSaveAsNew"
        />
      </div> -->
      <div class="tab-area">
        <ul>
          <li
            v-for="tab in tabs"
            :key="tab.id"
            @click="chooseTab(tab.id)"
            :class="[{ active: selectedTab === tab.id }]"
          >
            {{ tab.name }}
          </li>
        </ul>
      </div>
    </header>
    <div class="layout-wrapper">
      <SlideYDownTransition>
        <div v-if="showAddLayerPopup" class="mask"></div>
      </SlideYDownTransition>
      <simplebar class="layout-contents" data-simplebar-auto-hide="true">
        <div
          v-show="selectedTab === 'layers'"
          class="list-view-area"
          :key="'layers'"
        >
          <LayerManager :isEditView="getConfig.isTempWidgets" />
        </div>
        <div v-show="selectedTab === 'map_styles'" :key="'map-styles'">
          <MapStyleList />
        </div>
        <div v-show="selectedTab === 'settings'" :key="'settings'">
          <SettingsList />
        </div>
      </simplebar>
    </div>

    <!-- <div v-if="getConfig.isTempWidgets" class="button-area shadow-top">
      <div class="popup-wrapper">
        <Button
          type="save"
          icon="add_box"
          text="Create Layer"
          id="CreateLayer"
          @click="toggleLayerPopup()"
        />
        <SlideYDownTransition>
          <AddNewlayerOptions
            v-if="showAddLayerPopup"
            @close="toggleLayerPopup()"
          />
        </SlideYDownTransition>
      </div>
      <expand />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapStyleList from "@/components/metrics/views/MapStyleList";
import LayerManager from "@/components/metrics/containers/LayerManager";
import Button from "@/components/global/views/Button";
import ButtonWithDropdown from "@/components/global/views/ButtonWithDropdown";
import AddNewlayerOptions from "@/components/metrics/modals/AddNewlayerOptions";
import SettingsList from "@/components/metrics/views/SettingsList";
import {
  SlideYDownTransition,
  SlideXLeftTransition,
  FadeTransition,
} from "vue2-transitions";

export default {
  components: {
    MapStyleList,
    LayerManager,
    Button,
    ButtonWithDropdown,
    AddNewlayerOptions,
    SettingsList,
    SlideYDownTransition,
    SlideXLeftTransition,
    FadeTransition,
  },
  data() {
    return {
      gridFilter: {},
      customName: "",
      selectedTab: "layers",
      showAddLayerPopup: false,
      tabs: [
        {
          id: "layers",
          name: "Layers",
        },
        {
          id: "map_styles",
          name: "Map Styles",
        },
        {
          id: "settings",
          name: "Overlays",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("MetricStudio", [
      "getSelectedEntity",
      "getEntityAggregations",
      "getGridAggregation",
      "getGridColumn",
      "getGridFilters",
      "isSaveInProgress",
      "getSelectedProperties",
    ]),
    ...mapGetters("Datasources", ["getDataSourceDetails"]),
    ...mapGetters("StudioManager", ["getConfig"]),
    ...mapGetters("Dashboards", ["getConsoles"]),
    getDashboardName() {
      if (this.getConfig && this.getConfig.name) {
        return this.getConfig.name;
      } else {
        return "Locale.ai";
      }
    },
    getGridAggregations() {
      return [
        {
          id: this.getSelectedEntity.entity_id_col,
          name: this.getSelectedEntity.entity_id_col,
          column: this.getSelectedEntity.entity_id_col,
          aggregation: "sum",
        },
        ...this.getEntityAggregations,
      ];
    },
    selectedEntity: {
      get() {
        return this.getSelectedEntity;
      },
      async set(value) {
        await this.setSelectedEntity(value);
        this.fetchMetricData();
      },
    },
    gridColumn: {
      get() {
        return this.getGridColumn || this.getGridAggregations[0] || null;
      },
      set(value) {
        this.setGridColumn(value);
      },
    },
    whereColumns() {
      return this.getDataSourceDetails(
        this.selectedEntity.getBaseDatasource().datasource_id
      ).columns.filter(item => {
        return item.is_dimension;
      });
    },
    getColumns() {
      if (!this.getSelectedEntity) return;
      return this.getDataSourceDetails(
        this.getSelectedEntity.getBaseDatasource().datasource_id
      ).columns;
    },
  },
  methods: {
    ...mapActions("Popup", ["toggleEntityConfiguration"]),
    ...mapActions("MetricStudio", [
      "setGridColumn",
      "setGridAggregation",
      "addGridFilter",
      "removeGridFilter",
      "fetchMetricData",
      "createNewMetric",
      "toggleMetricDetailsPopup",
      "toggleFilterCreationPopup",
      "togglePropertyCreationPopup",
    ]),
    emitSaveOrSaveAsNew({ showSaveAsNewButton }) {
      if (showSaveAsNewButton) {
        this.$emit("clickSave", { showSaveAsNewButton });
      } else {
        // See if dashboard data is present in the store:
        if (this.getConsoles) {
          // Get the current console:
          let currentConsole = this.getConsoles.find(
            consoles => consoles.id == this.$route.query.dashboard_id
          );
          // If console data is present for currently opened console pass the data for prefilling of modal form:
          this.$emit("clickSave", {
            dashboardData: {
              name: currentConsole.name,
              description: currentConsole.description,
            },
            showSaveAsNewButton,
          });
        } else {
          // If console data is not present, simply don't pass the data and the form will be empty.
          this.$emit("clickSave", { showSaveAsNewButton });
        }
      }
    },
    toggleLayerPopup() {
      this.showAddLayerPopup = !this.showAddLayerPopup;
    },
    saveMetric() {
      if (this.selectedEntity) {
        this.createNewMetric();
      }
    },
    chooseTab(tabId) {
      this.selectedTab = tabId;
    },
  },
  watch: {
    gridFilter(value) {
      this.addGridFilter({
        column: value.select1.id,
        condition: value.select2.name,
        value: value.select3.name,
      });
    },
  },
};
</script>

<style lang="scss" scoepd>
.metric-studio-side-panel {
  background-color: var(--color-default-background);
  display: flex;
  flex-direction: column;
  z-index: 999;
  transition: 0.2s all ease-in-out;
  border-top: 1px solid var(--border-color);
  border-right: 1px solid var(--border-color);
  overflow: hidden; /* NEW */
  min-width: 0;

  .card-button {
    width: auto;
    background: var(--color-transparent);
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--color-primary);
    transition: 0.3s all ease-in-out;

    &:hover {
      cursor: pointer;
      background: var(--color-primary-light);
    }

    &:active {
      transform: scale(0.95);
    }

    p {
      margin: 0;
      padding: 0 5px 0 10px;
      font-size: 0.8em;
    }

    .icon {
      border-radius: 50%;
      margin: 3px;

      i {
        padding: 5px;
        transition: 0.2s all ease-in-out;

        &.rotate {
          transform: rotate(135deg);
        }
      }
    }
  }

  .tab-area {
    padding: 0px 15px;

    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      list-style-type: none;

      li {
        padding: 10px 15px 15px 15px;
        border-bottom: 2px solid var(--color-transparent);
        display: flex;
        flex-direction: row;
        align-items: center;
        opacity: 0.7;
        border-radius: 5px 5px 0 0;

        i {
          margin-right: 7px;
        }

        &.active {
          opacity: 1;
          color: var(--color-primary);
          border-bottom: 2px solid var(--color-primary);
        }

        &:hover {
          cursor: pointer;
          background: var(--color-primary-light);
        }
      }
    }
  }

  .layout-wrapper {
    min-width: 0;
    height: 100%;
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .layout-contents {
    min-width: 0;
    flex: 1;
    height: 100%;
    overflow-y: auto;
    // position: relative;
    padding-bottom: 10px;

    .mask {
      position: absolute;
      z-index: 99;
      top: 0;
      width: 100%;
      height: 100%;
      background: var(--popup-background-color);
    }

    .no-layers {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 200px;
        height: auto;
        margin-top: 100px;
      }

      p {
        padding: 0 20px;
        text-align: center;
        opacity: 0.8;
      }
    }
  }

  .list-view-area {
    display: flex;
    flex-direction: column;
    padding-top: 5px;
    position: relative;
  }

  h3 {
    margin-bottom: 10px;
    margin-top: 10px;
    font-weight: bold;
    font-size: 1em;
  }

  .sidepanel-contents {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;

    max-height: 100%;
  }

  .button-area {
    z-index: 99;
    position: relative;
    background-color: var(--color-secondary);
    padding: 10px 10px;
    box-shadow: 0 -6px 10px var(--popup-background-color);
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .popup-wrapper {
      position: relative;
    }

    .add-button {
      outline: none !important;
      background: var(--color-primary-light);
      padding: 10px;
      border: 0;
      border-radius: 5px;
      padding: 10px 15px;
      color: var(--color-primary);
      font-weight: bold;
      transition: 0.3s all ease-in-out;
      display: flex;
      flex-direction: row;
      align-items: center;

      i {
        margin-right: 10px;
      }

      &:hover {
        cursor: pointer;
        background: var(--color-primary);
        color: var(--color-secondary);
      }

      &:active {
        transform: scale(0.9);
      }
    }

    .save-button {
      @extend .add-button;
      background: var(--color-primary);
      color: var(--color-secondary);

      &:hover {
        background: var(--color-accent);
        color: var(--color-secondary);
      }

      &.disabled {
        background: var(--font-color-unselected);
        color: var(--font-color);

        &:hover {
          background: var(--font-color-unselected);
          color: var(--font-color);
          cursor: not-allowed;
        }
      }
    }
  }

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 98;
    background: var(--color-secondary);
    border-bottom: 1px solid var(--border-color);
    padding: 3px 0 0 0;

    .title-area {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 5px;
    }

    h1.title {
      font-size: 1.2em;
      font-weight: bold;
    }
  }

  .chit-area {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 5px;

    .select-chits {
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: var(--color-primary-light);
      padding: 5px 5px 5px 15px;
      border-radius: 50px;
      margin: 0px 7px 7px 0px;

      i {
        font-size: 18px;
        padding: 5px;
        background: var(--color-primary);
        border-radius: 50%;
        color: var(--color-secondary);
        margin-left: 10px;

        &:hover {
          cursor: pointer;
        }

        &:active {
          transform: scale(0.96);
        }
      }
    }
  }

  .grid-section {
    border-radius: 5px;
    background-color: var(--color-secondary);
    margin: 5px 0 5px 0;

    .grid-selection-list {
      display: flex;
      flex-direction: column;
      padding: 10px 20px 10px 20px;
      label {
        span {
          opacity: 0.6;
        }
        div.minimal-drop-down {
          color: var(--font-color);
          margin-top: 10px;
        }
      }

      h3 {
        margin-bottom: 10px;
        margin-top: 5px;
        font-weight: bold;
        font-size: 1em;
      }

      .aggregation-chits {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 5px;
        flex-wrap: wrap;

        .chit {
          padding: 2px 10px;
          margin: 5px;
          font-size: 0.8em;
          background: var(--border-color);
          border-radius: 15px;
          transition: 0.3s all ease-in-out;
          text-transform: uppercase;

          &:hover {
            cursor: pointer;
            background-color: var(--color-primary-light);
            color: var(--color-primary);
          }

          &:active {
            transform: scale(0.95);
          }

          &.active {
            background-color: var(--color-primary);
            color: var(--color-secondary);
          }
        }
      }
    }
  }
}
</style>
